import { Recording } from '../../../queries/ats/recordings/types/recording';

export function getDeleteMode(recordings: Recording[]) {
  return recordings.every((rec) => rec.deleteMode === 'auto') ? 'auto' : 'manual';
}
